import { render } from "./MainLots.vue?vue&type=template&id=055c4793&scoped=true"
import script from "./MainLots.vue?vue&type=script&lang=js"
export * from "./MainLots.vue?vue&type=script&lang=js"

import "./MainLots.vue?vue&type=style&index=0&id=055c4793&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055c4793"]])

export default __exports__